/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import {
	IDataResponseAuth,
	IReqRegisterDevice,
	IRequestAuth,
	IResponseAuth
} from '@pacifico/interfaces/auth-api.interface';
import { AuthService } from '@pacifico/services/api/auth/auth.service';
import { TokenService } from '@pacifico/services/api/token.service';
import { ModalAlertService } from '@pacifico/services/local/alert.service';
import { LoaderService } from '@pacifico/services/local/my-loader.service';
import { LocalStorageService } from '@pacifico/services/local/storage/local-storage.service';
import { TypeChangeService } from '@pacifico/services/local/type-change.service';
import { PATH_DASHBOARD } from '@pacifico/utils/path-page';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { ReCaptchaV3Service } from 'ng-recaptcha';

@Component({
	selector: 'app-login-form',
	templateUrl: './login-form.component.html',
	styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {
	@Input() showTabDni = false;
	@Output() requestPasswordEvent = new EventEmitter<boolean>();
	isCheckedRemember!: boolean;
	@Input() user = { code: '', password: '', type: 'L' };
	responseAuth!: IResponseAuth;
	dataResponseAuth!: IDataResponseAuth;
	@Input() codeLogin = '';
	typeInputPassword = 'password';
	codeTemp = '';
	@ViewChild('myform') myform!: NgForm;
	messageErrorCode = '';
	messageErrorPassword = '';
	showSecondFactor = false;
	@ViewChild('mySecondFactorform') mySecondFactorform!: NgForm;
	@Input() tokenCode = '';
	messageErrorTokenCode = '';
	messageErrorTokenResult = '';
	constructor(
		private _loginService: AuthService,
		private _tokenService: TokenService,
		private _router: Router,
		private _localStorageService: LocalStorageService,
		private _recaptchaV3Service: ReCaptchaV3Service,
		private _typeChangeService: TypeChangeService,
		private _serviceModalAlert: ModalAlertService,
		private _loaderService: LoaderService,
		private gtmService: GoogleTagManagerService
	) {}

	ngOnInit(): void {
		this.showTabDni = this.user.type == 'L';
		this.codeTemp = this.user.code;

		this.initialMessage();
		this.isCheckedRemember = this._localStorageService.getItem('rememberme') ?? false;
	}

	requestAuth: IRequestAuth = {
		appVersion: '1.7',
		environment: 'W',
		typeDocument: 0,
		password: '',
		userPartnerDocument: '',
		captchaToken: '',
		agentToken: this._localStorageService.getItem('agentToken') ?? '',
		agentUser: window.navigator.userAgent
	};

	clickRememberMe(): void {
		this._localStorageService.setItem('rememberme', !this.isCheckedRemember);
		if (this.isCheckedRemember && localStorage.getItem('user') !== null) {
			this._serviceModalAlert
				.showWarning('¿Esta seguro que no desea recordar sus datos?', 'Atención', false)
				.afterClosed.subscribe((response) => {
					this.isCheckedRemember = response === 0 ? false : true;

					if (!this.isCheckedRemember) {
						this.myform.resetForm({
							isCheckedRemember: this.isCheckedRemember,
							userCode: ''
						});
						this._localStorageService.removeItem('user');
					} else {
						this.myform.resetForm({
							userCode: this.user.code,
							isCheckedRemember: this.isCheckedRemember,
							userPassword: this.user.password
						});
					}
					this._serviceModalAlert.dialogComponentRef.destroy();
					this._localStorageService.setItem('rememberme', this.isCheckedRemember);
				});
		}
	}

	clickLogin(): void {
		this.requestAuth.userPartnerDocument = this.user.code === this.codeTemp ? this.codeLogin : this.user.code;
		this.requestAuth.password = this.user.password;
		this.requestAuth.typeDocument = this.user.type === 'L' ? 0 : 1;

		this._recaptchaV3Service.execute('login').subscribe(
			(token) => {
				this.requestAuth.captchaToken = token;
				this._loginService.auth(this.requestAuth).subscribe((result) => {
					this.dataResponseAuth = result;

					switch (result.status.code) {
						case '1009':
							void this._router.navigateByUrl(PATH_DASHBOARD.dashboard.justPath);

							break;
						case '0000':
							this._loaderService.clearParameters();
							this.saveUSer();
							this.responseAuth = {
								codeMessageFirst: result.data.codeMessageFirst,
								sessionId: result.data.sessionId,
								user: result.data.user,
								changeType: result.data.changeType,
								token: result.data.token,
								showHeader: result.data.showHeader,
								showSecondFactor: result.data.showSecondFactor,
								uriHomeWeb: result.data.uriHomeWeb,
								uriHomeMobile: result.data.uriHomeMobile,
								msjTransfe1: result.data.msjTransfe1,
								msjTransfe2: result.data.msjTransfe2,
								msjTransfe3: result.data.msjTransfe3
							};
							void this.gtmService.pushTag({ login: 'okLogin' });
							this._typeChangeService.changeType = result.data.changeType;
							this._tokenService.setToken(this.responseAuth);
							this._localStorageService.setItem('agentToken', result.data.sessionId);

							this.showSecondFactor = result.data.showSecondFactor;
							this.myform.resetForm({
								isCheckedRemember: this.isCheckedRemember
							});

							if (result.data.codeMessageFirst === '0001' || result.data.showHeader) {
								void this._router.navigateByUrl('auth/first-login');
								return;
							}

							if (!this.showSecondFactor) {
								void this._router.navigateByUrl(PATH_DASHBOARD.dashboard.justPath);
								return;
							}

							break;
						case '1001':
							this.messageErrorCode = result.status.message;
							this.myform.resetForm({
								isCheckedRemember: this.isCheckedRemember
							});
							this.myform.controls.userCode.markAsTouched();
							void this.gtmService.pushTag({ login: 'rejectedLogin' });
							break;
						case '1002':
							if (this._localStorageService.getItem('user') !== null) {
								this.messageErrorPassword = 'La contraseña es incorrecta';
								this.myform.controls.userPassword.reset();
								this.myform.controls.userPassword.markAsTouched();
							} else {
								this.messageErrorCode = result.status.message.replace('�', 'ñ');
								this.myform.resetForm({
									isCheckedRemember: this.isCheckedRemember
								});
								this.myform.controls.userCode.markAsTouched();
							}
							void this.gtmService.pushTag({ login: 'rejectedLogin' });
							break;
						case '5555':
							void this.gtmService.pushTag({ login: 'rejectedLogin' });
							break;
						case '1003':
							if (this._localStorageService.getItem('user') !== null) {
								this.messageErrorPassword = 'El usuario esta bloqueado';
								this.myform.controls.userPassword.reset();
								this.myform.controls.userPassword.markAsTouched();
							} else {
								this.messageErrorCode = result.status.message;
								this.myform.resetForm({
									isCheckedRemember: this.isCheckedRemember
								});
								this.myform.controls.userCode.markAsTouched();
							}
							void this.gtmService.pushTag({ login: 'rejectedLogin' });
							break;
						default: {
							this.messageErrorCode = result.status.message.replace('�', 'ñ');
							this.user.code = this.user.code === this.codeTemp ? this.codeTemp : '';

							if (this._localStorageService.getItem('user') === null) {
								this.myform.controls.userCode.reset();
								this.myform.controls.userCode.markAsTouched();
							}
							void this.gtmService.pushTag({ login: 'rejectedLogin' });
							break;
						}
					}
				});
			},
			(err) => {
				console.log('error de captcha', err);
			}
		);
	}

	saveUSer(): void {
		this._tokenService.setPasswordValue(this.user.password);
		if (this.isCheckedRemember) {
			this.user.code = this.requestAuth.userPartnerDocument;
			this.user.password = '';
			this._localStorageService.setItem('user', this.user);
		} else {
			this._localStorageService.removeItem('user');
			this.user.code = '';
			this.user.password = '';
		}
	}

	changeInput(): void {
		if (this.user.password !== '') {
			this.typeInputPassword = this.typeInputPassword === 'password' ? 'text' : 'password';
			setTimeout(() => {
				this.typeInputPassword = 'password';
			}, 500);
		}
	}

	validInputCode(): boolean {
		return this.myform?.controls.userCode?.touched && this.myform?.controls.userCode?.invalid;
	}

	validateInputPassword(): boolean {
		return this.myform?.controls.userPassword?.touched && this.myform?.controls.userPassword?.invalid;
	}

	clickTab(showDni: boolean): void {
		if (this.isCheckedRemember && localStorage.getItem('user') !== null) {
			this.myform.resetForm({
				userCode: this.user.code,
				isCheckedRemember: true,
				userPassword: this.user.password
			});
		} else {
			this.showTabDni = showDni;
			this.initialMessage();
			if (!this.isCheckedRemember) {
				this.myform.resetForm({
					isCheckedRemember: false,
					userPassword: this.user.password
				});
			} else {
				this.myform.resetForm({
					isCheckedRemember: true,
					userCode: '',
					userPassword: this.user.password
				});
			}
			this.user.code = '';
			this.user.type = showDni ? 'L' : 'S';
		}
	}

	getUser(): void {
		const hide = '********';
		const lsUser = localStorage.getItem('user');

		if (lsUser !== null) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
			this.user = JSON.parse(lsUser);
			const size = this.user.code.length;
			this.codeLogin = this.user.code;
			this.user.code = hide.slice(0, size - 2) + this.user.code.slice(size - 2);
		}
	}

	initialMessage(): void {
		this.messageErrorCode = this.showTabDni ? 'Coloque un DNI válido' : 'Coloque un código de socio válido';
		this.messageErrorPassword = 'La contraseña debe tener entre 8 a 10 caracteres.';
		this.messageErrorTokenCode = 'Debe ingresar codigo token';
	}

	validTokenCode(): boolean {
		return this.mySecondFactorform?.controls.tokenCode?.touched && this.mySecondFactorform?.controls.tokenCode?.invalid;
	}

	sendToken(): void {
		if (this.mySecondFactorform.valid) {
			const request: IReqRegisterDevice = {
				operationCode: this._tokenService.getSessionID(),
				personId: this._tokenService.getUser(),
				tokenCode: this.mySecondFactorform.controls.tokenCode.value as string
			};
			this._loginService.registerDevice(request).subscribe((response) => {
				if (response && response.status && response.status.code === '0000') {
					void this._router.navigateByUrl(PATH_DASHBOARD.dashboard.justPath);
				} else {
					this.messageErrorTokenResult = response.status.message;
					this.mySecondFactorform.resetForm();
				}
			});
		}
	}

	backToLogin(): void {
		this.showSecondFactor = false;
		this.messageErrorTokenResult = '';
		this.mySecondFactorform.resetForm();
	}
}
